import React from "react";
import DocumentProjectDetailsSection from "./fixed/DocumentProjectDetailsSection";
import DocumentAuthorizationSection from "./fixed/DocumentAuthorizationSection";
import HighRiskActivities from "./default/HighRiskActivities";
import MethodItemType from "./dynamic/MethodItemType";
import SwmsContentManagementType from "./dynamic/SwmsContentManagementType";
import RiskMatrixSection from "./default/RiskMatrixSection";
import JSASection from "./default/JSASection";
import EmergencyContacts from "./default/EmergencyContacts";

const FIXED_SECTIONS = [
  "document_project_details",
  "document_authorization"
];

const SECTION_COMPONENTS = {
  document_project_details: DocumentProjectDetailsSection,
  document_authorization: DocumentAuthorizationSection,
  high_risk_activities: HighRiskActivities,
  risk_matrix: RiskMatrixSection,
  job_steps_hazards_consequences_controls: JSASection,
  emergency_contacts: EmergencyContacts
};

const SECTION_TYPE_COMPONENTS = {
  method_item_type: MethodItemType,
  swms_content_management: SwmsContentManagementType,
};

function getSectionComponent(sequenceItem, sectionEntry) {
  const sectionKey = sequenceItem && sequenceItem.item_key;
  const sectionType = sectionEntry && sectionEntry.type;

  return (
    SECTION_COMPONENTS[sectionKey] ||
    SECTION_TYPE_COMPONENTS[sectionType] ||
    null
  );
}

export default function PreviewSections({ swmsData }) {
  const sections = (swmsData && swmsData.sections) || {};
  const meta = (swmsData && swmsData.meta) || {};
  const sequenceMeta = meta.sequence || {};

  const fixedSequence = (sequenceMeta.fixed || []).sort((a, b) => 
    (a.sequence_order || 0) - (b.sequence_order || 0)
  );
  const activeSequence = (sequenceMeta.active || []).sort((a, b) => 
    (a.sequence_order || 0) - (b.sequence_order || 0)
  );

  const allSequenceItems = [...fixedSequence, ...activeSequence];

  const visibleSections = allSequenceItems.filter((sequenceItem) => {
    const { item_key: sectionKey, active: isSequenceActive } = sequenceItem;
    const sectionEntry = sections[sectionKey];
    const sectionData = sectionEntry && sectionEntry.data;
    const Component = getSectionComponent(sequenceItem, sectionEntry);

    if (sectionData == null) return false;

    if (FIXED_SECTIONS.includes(sectionKey)) {
      return Component !== null;
    }

    if (isSequenceActive === 0) return false;
    if (sectionData && sectionData.toggle === 0) return false;
    return Component !== null;
  });

  return (
    <div>
      {visibleSections.map((sequenceItem, index) => {
        const { item_key: sectionKey, display_name: displayName } = sequenceItem;
        const sectionEntry = sections[sectionKey];
        const sectionData = sectionEntry && sectionEntry.data;
        const Component = getSectionComponent(sequenceItem, sectionEntry);
        const targetId = `sec-${sectionKey}`;

        return (
          // <div key={sectionKey} id={targetId} style={{ scrollMarginTop: "140px" }}>
            <Component
              key={sectionKey}
              sectionData={sectionData}
              targetId={targetId}
              swmsData={swmsData}
              displayName={displayName}
              sectionNumber={index + 1}
            />
          // </div>
        );
      })}
    </div>
  )
}